export const OPEN_LYRICS_PANEL='OPEN_LYRICS_PANEL';
export const CLOSE_LYRICS_PANEL='CLOSE_LYRICS_PANEL';
export const REQUEST_LYRICS='REQUEST_LYRICS';
export const ON_TOP_BUTTON='ON_TOP_BUTTON';
export const OFF_TOP_BUTTON='OFF_TOP_BUTTON';
export const PLAY_AT_TOP='PLAY_AT_TOP';
export const CLOSE_AT_TOP='CLOSE_AT_TOP';
export const PLAY_VIDEO='PLAY_VIDEO';
export const PAUSE_VIDEO='PAUSE_VIDEO';
export const TOGGLE_REPEAT='TOGGLE_REPEAT';
export const PLAY_NEXT_VIDEO='PLAY_NEXT_VIDEO';
export const PLAY_NEXT_VIDEO_AT_TOP='PLAY_NEXT_VIDEO_AT_TOP';
export const CLEAR_LYRICS='CLEAR_LYRICS';
export const NEXT_TRACK='NEXT_TRACK';
export const PREVIOUS_TRACK='PREVIOUS_TRACK';
export const TOGGLE_QUALITY='TOGGLE_QUALITY';

// export const 

